import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FeedbackForm from "./components/FeedbackForm";
import HomePage from "./pages/HomePage";
import StartHerePage from "./pages/StartHerePage";
import SeriesOverviewPage from "./pages/SeriesOverviewPage";
import BookDetailPage from "./pages/BookDetailPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminNotificationsPage from "./pages/AdminNotificationsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/start-here" element={<StartHerePage />} />
          <Route path="/books" element={<Navigate to="/start-here" replace />} />
          <Route path="/series-overview" element={<SeriesOverviewPage />} />
          <Route path="/book/:age" element={<BookDetailPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/notifications" element={<AdminNotificationsPage />} />
        </Routes>
        <Footer />
        <FeedbackForm />
      </BrowserRouter>
    </div>
  );
}

export default App;
